import {
  Accordion,
  AccordionItem,
  AccordionButton,
  Box,
  AccordionPanel,
  AccordionIcon,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import React from 'react';
import CkeditorDisplay from './CkeditorDisplay';

interface CoursePlanProps {
  units: {
    id: string;
    name: string;
    programInfoDescription: string;
    modules: {
      id: string;
      name: string;
    }[];
  }[];
}

const CoursePlan = (props: CoursePlanProps) => {
  const { units } = props;
  return (
    <Accordion
      marginTop={'20px'}
      width={'100%'}
      defaultIndex={[0]}
      allowMultiple
    >
      {units.map((unit, index) => {
        const foundIndex = units.findIndex((u) => u.id === unit.id);
        if (foundIndex !== index) {
          return null;
        }
        return (
          <AccordionItem key={unit.id}>
            <h2>
              <AccordionButton _expanded={{ bg: 'stemiBlue.500', color: 'white' }}>
                <Box as="span" flex="1" textAlign="left">
                  {unit.name}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              {unit.programInfoDescription ? (
                <CkeditorDisplay
                  flex={3}
                  dangerouslySetInnerHTML={{
                    __html: unit.programInfoDescription,
                  }}
                />
              ) : (
                <UnorderedList>
                  {unit.modules.map((module) => (
                    <ListItem key={module.id}>{module.name}</ListItem>
                  ))}
                </UnorderedList>
              )}
            </AccordionPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default CoursePlan;
